import React from 'react';

import { getClientUrls, UpgradeAccount } from '@paragon/login-tools';

import { useAppSelector } from './hooks';
import { ServicesPage } from './ServicesPage';

export function Account() {
  const paragonServicesUrl = useAppSelector(getClientUrls).servicesUrl;

  return (
    <ServicesPage>
      <UpgradeAccount showGreeting successUrl={paragonServicesUrl} cancelUrl={`${paragonServicesUrl}account`} />
    </ServicesPage>
  );
}
